import types from "./types";

const initialState = {
    oetSelected: null,
    runSelected: null,
    osloaded: false,
    error: null,
    loading: false,
    loaded: false,
    loadingSsoti: false,
    loadingSites: false,
    site_pagination: {
        actualPage: 1,
        previous: null,
        next: null,
        pages: 0,
        count: 0
    },
    ssoti_pagination: {
        actualPage: 1,
        previous: null,
        next: null,
        pages: 0,
        count: 0
    }
};

export default (state = initialState, action) => {
    switch (action.type) {
        case types.SITES_CHANGE_PAGE: {
            return {
                ...state,
                site_pagination: {
                    ...state.site_pagination,
                    actualPage: action.payload.page
                }
            };
        }

        case types.SITES_UPDATE_PAGINATION: {
            return {
                ...state,
                site_pagination: {
                    ...state.site_pagination,
                    actualPage: action.payload.actual,
                    pages: action.payload.pages,
                    next: action.payload.next,
                    previous: action.payload.previous,
                    count: action.payload.count
                }
            };
        }

        case types.SSOTITEM_CHANGE_PAGE: {
            return {
                ...state,
                ssoti_pagination: {
                    ...state.ssoti_pagination,
                    actualPage: action.payload.page
                }
            };
        }

        case types.SSOTITEM_UPDATE_PAGINATION: {
            return {
                ...state,
                ssoti_pagination: {
                    ...state.ssoti_pagination,
                    actualPage: action.payload.actual,
                    pages: action.payload.pages,
                    next: action.payload.next,
                    previous: action.payload.previous,
                    count: action.payload.count
                }
            };
        }

        case types.EXECUTE_SERVICE:{
            return {
                ...state,
                loading: true,
                loaded: false,
            }
        }

        case types.EXECUTE_SERVICE_FAIL:
        case types.EXECUTE_SERVICE_SUCCESS:{
            return {
                ...state,
                loading: false,
                loaded: true,
            }
        }

        case types.CREATE_OET_IN:
        case types.GET_RUN_LIST: // RUNS
        case types.GET_RUN_DETAIL:
        case types.CREATE_RUN:
        case types.UPDATE_RUN: {
            return {
                ...state,
                loading: true,
                loaded: false,
                osloaded: false
            };
        }
        case types.GET_SITES: {
            return {
                ...state,
                oetSelected: {
                    ...state.oetSelected,
                    sites: null
                },
                loadingSites: true,
                loading: true,
                loaded: false,
                osloaded: false
            };
        }

        case types.GET_SSOTITEM: {
            return {
                ...state,
                oetSelected: {
                    ...state.oetSelected,
                    ssoti: null
                },
                loadingSsoti: true,
                loading: true,
                loaded: false,
                osloaded: false
            };
        }

        case types.CREATE_OET_IN_FAIL: {
            return {
                ...state,
                error: action.payload,
                loading: false,
                loaded: false,
                osloaded: false
            };
        }
        case types.CREATE_OET_IN_SUCCESS: {
            return {
                ...state,
                oetSelected: action.payload,
                loading: false,
                loaded: true,
                osloaded: true
            };
        }
        case types.GET_OET_IN_DETAIL: {
            return {
                ...state,
                loading: true,
                loaded: false,
                osloaded: false
            };
        }
        case types.GET_OET_IN_DETAIL_FAIL: {
            return {
                ...state,
                error: action.payload,
                loading: false,
                loaded: false,
                osloaded: false
            };
        }
        case types.GET_OET_IN_DETAIL_SUCCESS: {
            return {
                ...state,
                oetSelected: {
                    ...state.oetSelected,
                    ...action.payload
                },
                loading: false,
                loaded: true,
                osloaded: true
            };
        }
        case types.GET_SITES_FAIL: {
            return {
                ...state,
                error: action.payload,
                oetSelected: {
                    ...state.oetSelected,
                    sites: null
                },
                loadingSites: false,
                loading: false,
                loaded: false,
                osloaded: false
            };
        }
        case types.GET_SITES_SUCCESS: {
            return {
                ...state,
                oetSelected: {
                    ...state.oetSelected,
                    sites: action.payload
                },
                loadingSites: false,
                loading: false,
                loaded: true,
                osloaded: true
            };
        }
        case types.GET_SSOTITEM_FAIL: {
            return {
                ...state,
                error: action.payload,
                oetSelected: {
                    ...state.oetSelected,
                    ssoti: null
                },
                loadingSsoti: false,
                loading: false,
                loaded: false,
                osloaded: false
            };
        }
        case types.GET_SSOTITEM_SUCCESS: {
            return {
                ...state,
                oetSelected: {
                    ...state.oetSelected,
                    ssoti: action.payload
                },
                loadingSsoti: false,
                loading: false,
                loaded: true,
                osloaded: true
            };
        }

        // RUNS

        case types.GET_RUN_LIST_SUCCESS: {
            return {
                ...state,
                oetSelected: {
                    ...state.oetSelected,
                    runs: action.payload
                },
                loading: false,
                loaded: true
            };
        }

        case types.GET_RUN_LIST_FAIL: {
            return {
                ...state,
                oetSelected: {
                    ...state.oetSelected,
                    runs: []
                },
                loading: false,
                loaded: false
            };
        }

        case types.UPDATE_RUN_SUCCESS:
        case types.CREATE_RUN_SUCCESS:
        case types.GET_RUN_DETAIL_SUCCESS: {
            return {
                ...state,
                runSelected: action.payload,
                loading: false,
                loaded: true
            };
        }

        case types.UPDATE_RUN_FAIL: {
            let runSelected = null;
            const error = action.payload;

            if (error) {
                if (error.status === 400) {
                    runSelected = state.runSelected;
                }
            }
            return {
                ...state,
                runSelected,
                loading: false,
                loaded: false
            };
        }

        case types.CREATE_RUN_FAIL:
        case types.GET_RUN_DETAIL_FAIL: {
            return {
                ...state,
                runSelected: null,
                loading: false,
                loaded: false
            };
        }

        case types.SYNCQUANTITYCONTRACT:
        case types.CHANGE_QUANTITY_LIMIT:
        case types.START_PR_VALIDATION:
        case types.SYNCWBS:
        case types.SYNCVOA: {
            return {
                ...state,
                loading: true,
                loaded: false
            };
        }

        case types.SYNCQUANTITYCONTRACT_SUCCESS:
        case types.CHANGE_QUANTITY_LIMIT_SUCCESS:
        case types.START_PR_VALIDATION_SUCCESS:
        case types.SYNCWBS_SUCCESS:
        case types.SYNCVOA_SUCCESS: {
            return {
                ...state,
                loading: false,
                loaded: true
            };
        }

        case types.SYNCQUANTITYCONTRACT_FAIL:
        case types.CHANGE_QUANTITY_LIMIT_FAIL:
        case types.START_PR_VALIDATION_FAIL:
        case types.SYNCWBS_FAIL:
        case types.SYNCVOA_FAIL: {
            return {
                ...state,
                loading: false,
                loaded: false
            };
        }
        // CANCEL SSOT ITEMS
        case types.CANCEL_SSOT_ITEMS: {
            return {
                ...state,
                loading: true,
                loaded: false
            };
        }
        case types.CANCEL_SSOT_ITEMS_FAIL: {
            return {
                ...state,
                loading: false,
                loaded: false
            };
        }
        case types.CANCEL_SSOT_ITEMS_SUCCESS: {
            return {
                ...state,
                loading: false,
                loaded: true
            };
        }
        default: {
            return state;
        }
    }
};
